module.exports = __webpack_public_path__ + "img/looks_6.d57b635a.svg";